/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Breadcrumb as BC, Tooltip } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

const Breadcrumb = ({ data, onSelectItem }) => (
  <BC separator={<RightOutlined style={{ color: 'black', fontSize: '18px' }} />}>
    {data?.map((item, index) => (
      <Fragment key={item.key}>
        {(index < data?.length - 1)
          ? (
            <BC.Item onClick={() => onSelectItem(item)}>
              <Link to="">{String(item.text)?.length > 30
                ? <Tooltip placement="top" title={item.text}>...</Tooltip>
                : item.text}
              </Link>
            </BC.Item>
          )
          : (
            <BC.Item>
              {item.text?.length > 30
                ? <Tooltip placement="top" title={item.text}>...</Tooltip>
                : item.text}
            </BC.Item>
          )}
      </Fragment>
    ))}
  </BC>
)

Breadcrumb.propTypes = {
  data: PropTypes.array,
  onSelectItem: PropTypes.func
}

export default Breadcrumb
